import { render, staticRenderFns } from "./widthBar.vue?vue&type=template&id=2f400126&scoped=true&"
import script from "./widthBar.vue?vue&type=script&lang=js&"
export * from "./widthBar.vue?vue&type=script&lang=js&"
import style0 from "./widthBar.vue?vue&type=style&index=0&id=2f400126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f400126",
  null
  
)

export default component.exports